import React, { useEffect, useRef } from 'react';
import Button from '@mui/material/Button';

const ThankYouActivity = ({ activities, participants, newRegistration, state, email }) => {
    const titleRef = useRef();

    useEffect(() => {
        titleRef.current.scrollIntoView({
            behavior: "smooth",
        });
    }, []);

    const getTitle = () => {
        switch (state) {
            case 1: return 'Tack för din anmälan!';
            case 5: return 'Aktivit stängd';
            default: return '';
        }
    }

    return (
        <div className='thankyou'>
            <h1 ref={titleRef}>{getTitle()}</h1>
            <br />
            {state === 5 && <div>
                <p>Vi är ledsna men en, eller flera, av de aktiviteter som du valt är nu stängda. Det kan vara att de är fullbokade, eller att det är försent att boka.</p>
            </div>}
            {state !== 5 && <div>
                <p>
                    Till<br />
                    {activities.map(a => {
                        return (
                            <React.Fragment key={a.id}>
                                <span><b>{`${a.dateDisplay} - ${a.name}`}</b> {`${a.selection}`}</span>
                                <br />
                            </React.Fragment>)
                    })}
                    <br />
                    Anmälan gäller:<br />
                    {participants.map(p => {
                        return (
                            <React.Fragment key={p.id}>
                                <span key={p.name}><b>{p.name}</b></span>
                                <br />
                            </React.Fragment>
                        );
                    })}
                </p>
                <br />
                <p>Bekräftelse på er anmälan kommer att skickas till:<br /><b>{email}</b></p>
                <br />
                <p className='confirm-info'>Om du har några frågor så kan du maila till <a href='mailto:golf@stay4golf.se'>golf@stay4golf.se</a>, eller ringa oss på <a href='tel:040294400'>040 – 29 44 00.</a>
                    <br />Vi ses!</p>
                <br />
                <Button variant="contained" color="info" onClick={newRegistration} >Ny anmälan</Button>
                <br />
                <br />
                <a href="https://stay4golf.se/" target="_blank" rel="noopener noreferrer">https://stay4golf.se/</a>
            </div>}
        </div>
    );
}

export default ThankYouActivity;